import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

export default function Pending() {
  return (
    <div>
      <br />
      <Typography color="textSecondary" align="center">
        Thanks for registering! If you are here, it's probably because
        you finished your registration and attempted a login before an
        administrator could accept your pending registration. Please be 
        patient while they review your request. Once your registration has
        been accepted or denied, you will be the first to know! You will
        be sent an email with the status of your registration.
        
        Thanks for using the Gospel Hall Directory!
      </Typography>
      <br />
      <Button
        onClick={() => window.location = '/signin'}
        variant="contained"
        color="primary"
      >
        Back
      </Button>
    </div>
  );
}